namespace $.$$ {

	export class $shm_hitalama_map_widget_float_tabulator extends $.$shm_hitalama_map_widget_float_tabulator {

		@ $mol_mem
		table() {
			return this.widget().Table()?.remote() ?? null
		}

		head() {
			return this.table()?.table_head() ?? []
		}

		rows() {
			return this.table()?.rows_limited() ?? []
		}

		columns() {
			return this.head().map( ( title, index )=> ({
				title: String( title ),
				field: this.tabulator_field( index ),
				headerFilter: this.header_filter() ? 'input' : false,
				editor: this.editable() ? 'input' : false,
				headerSort: this.sortable(),
				sorter: 'string',
				resizable: this.resizable_columns(),
			}) )
		}

		tabulator_field( index: number ) {
			return 'col_' + index
		}

		data() {
			return this.rows().map( ( row, row_index )=> ({
				_hitalama_row: row_index,
				... Object.fromEntries( this.head().map( ( _, col_index )=> [
					this.tabulator_field( col_index ),
					row[ col_index ],
				] ) ),
			}) )
		}

		setting< Value >( name: string, next: Value | undefined, fallback: Value ): Value {
			const prev = ( this.widget().Data()?.val() ?? {} ) as Record< string, Value >
			if( next === undefined ) return prev[ name ] ?? fallback

			this.widget().Data( null )?.val({ ... prev, [ name ]: next })
			return next
		}

		layout( next?: string ) {
			return this.setting( 'layout', next, 'fitDataStretch' )
		}

		header_filter( next?: boolean ) {
			return this.setting( 'header_filter', next, false )
		}

		sortable( next?: boolean ) {
			return this.setting( 'sortable', next, true )
		}

		resizable_columns( next?: boolean ) {
			return this.setting( 'resizable_columns', next, false )
		}

		movable_columns( next?: boolean ) {
			return this.setting( 'movable_columns', next, false )
		}

		editable( next?: boolean ) {
			return this.setting( 'editable', next, false )
		}

		pagination( next?: boolean ) {
			return this.setting( 'pagination', next, false )
		}

		page_size( next?: number ) {
			return this.setting( 'page_size', next, 10 )
		}

		@ $mol_mem
		options() {
			return {
				layout: this.layout(),
				movableColumns: this.movable_columns(),
				resizableColumnFit: this.resizable_columns(),
				pagination: this.pagination() ? 'local' : false,
				paginationSize: this.page_size(),
				cellEdited: ( cell: any )=> {
					const row_index = cell.getRow().getData()._hitalama_row
					const col_index = Number( String( cell.getColumn().getField() ).replace( 'col_', '' ) )
					if( !Number.isFinite( row_index ) ) return
					if( !Number.isFinite( col_index ) ) return

					const table = this.table()
					if( !table ) return
					const rows = table.table_rows() ?? []
					const row = rows[ row_index ] ?? []
					const rows_next = rows.map( ( item, index )=> {
						if( index !== row_index ) return item
						const row_next = [ ... row ]
						row_next[ col_index ] = cell.getValue()
						return row_next
					} )

					table.table_rows( rows_next )
				},
			}
		}

		skip_drag( el: Element ) {
			if( el.closest( '.tabulator-table, .tabulator-headers' ) ) return true
			return super.skip_drag( el )
		}

		@ $mol_action
		settings_add() {
			this.widget().settings_widget_enabled( true )
		}

		@ $mol_action
		echarts_add() {
			const pos = this.Map_page().contextmenu_real_pos()
			const widget = this.map().widget_add( 'echarts', pos, 650, 460 )
			const table = this.table()
			if( table ) widget?.Table(null)?.remote( table )

			const chart = widget?.chart()
			chart?.Widget(null)?.remote( widget )

			widget?.settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}

	}

}
